import React, { useState, useEffect } from "react";
import {
  formateDate,
  loadPropertTypeImage,
  setLocalStorage,
  truncate,
} from "../../helpers/common";
import { ADTYPE_BUY, ADTYPE_LTR, INVENTORY_KEY } from "../../constants/common";
import Table from "react-bootstrap/Table";
import ActionDropdown from "./ActionDropdown";
import TableHeader from "./TableHeader";
import addressImage from "../../images/address-img.png";
import noImage from "../../images/no-image-placeholder.png";
import { pageURLs } from "../../constants/pageURLs";
import { useNavigate } from "react-router-dom";

const InventoryListing = (props) => {

  const navigate = useNavigate();
  const {
    showNoResult,
    handleSort,
    itemList,
    onItemEdit,
    onItemDelete,
    sort,
    emptyItemHtml,
  } = props;
  const columns = [
    { label: "Address ", sorting: "Yes", sortKey: "address" },
    // { accessor: 'email', label: 'Email', sorting:'Yes'  },
    { label: "Client", sorting: "Yes", sortKey: "client" },
    { label: "Type", sorting: "Yes", sortKey: "type" },
    { label: "Sell/Rent-out", sorting: "Yes", sortKey: "sell_rent" },
    { label: "Intros sent", sorting: "Yes", sortKey: "intros" },
    { label: "Date added", sorting: "Yes", sortKey: "date" },
  ];

  const handleInventoryItemClick = (inventoryId) => {
    setLocalStorage(INVENTORY_KEY, {
      inventoryId: inventoryId,
      isFromAgentDashboard: true,
    });
    navigate(pageURLs.memberInventoryDetails);
  };
  return (
    <div className="dashboard-table-wrap">
      <div className="table-responsive">
        {showNoResult && itemList !== null && itemList?.length > 0 ? (
          <Table className="table">
            <TableHeader
              columns={columns}
              handleSort={handleSort}
              sort={sort}
            />
        
              <tbody>
                {itemList.map((inventry, i) => {
                  const invPhoto = _.get(inventry, 'photos', null) || noImage
                  return (
                    <tr key={i}>
                      {/* <td>
                        <span className="d-inline-block client-name-style txt-overflow-style">
                          {truncate(_.get(inventry, "Add_Details", ""), 30)}
                        </span>
                      </td> */}
                      <td>
                        {_.get(inventry, "Location", "") ? (
                          <a
                            href={void 0}
                            role="button"
                            className="txt-no-underline client-name-style"
                            onClick={() => {
                              _.get(inventry, "IsPublished", 0) == 1 ?  handleInventoryItemClick(_.get(inventry, "Inv_Id", "")) : '';
                            }}
                          >
                            <div className="d-flex align-items-center justify-content-start">
                              <div className="table-address-img">
                                <img
                                  src={invPhoto}
                                  alt="inventoryImage"
                                ></img>
                              </div>
                              <span className="d-inline-block client-name-style txt-overflow-style">
                                {truncate(_.get(inventry, "Location", ""), 30)}
                              </span>
                            </div>{" "}
                          </a>
                        ) : (
                          ""
                        )}
                      </td>

                      <td>
                        {_.get(inventry, "FirstName", "") +
                          " " +
                          _.get(inventry, "LastName", "")}
                      </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-start">
                          <div className="property-location-icon">
                            {loadPropertTypeImage(
                              _.get(inventry, "Sub_PropertyTypeId", "") ||
                                _.get(inventry, "PropertyTypeId", "")
                            )}
                          </div>
                          <span className="d-inline-block client-property-style">
                            {_.get(inventry, "Type", "")}
                          </span>
                        </div>
                      </td>

                      <td>{_.get(inventry, "Sell_Rent", "")}</td>
                      <td>
                        <span className="table-badge-grey me-2">
                          {_.get(inventry, "IntroPending", "")} pending
                        </span>
                        <span className="table-badge-green">
                          <span className="d-inline-block align-text-bottom badge-tick-icon">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11.6844 3.62814C11.8552 3.799 11.8552 4.076 11.6844 4.24686L5.55936 10.3719C5.3885 10.5427 5.1115 10.5427 4.94064 10.3719L1.87814 7.30936C1.70729 7.1385 1.70729 6.8615 1.87814 6.69064C2.049 6.51979 2.326 6.51979 2.49686 6.69064L5.25 9.44378L11.0656 3.62814C11.2365 3.45729 11.5135 3.45729 11.6844 3.62814Z"
                                fill="#219653"
                              />
                            </svg>
                          </span>
                          {_.get(inventry, "IntroAccepted", "")} accepted
                        </span>
                      </td>
                      <td>
                        <div className="d-flex align-items-center justify-content-start">
                          <span>
                            {formateDate(
                              _.get(inventry, "CreatedOn", ""),
                              "shortMonth"
                            )}
                          </span>
                          <div className="social-btns-wrap no-bg-toggle ms-1">
                            <ActionDropdown
                              onItemEdit={onItemEdit}
                              onItemDelete={onItemDelete}
                              editText="Edit Inventory"
                              deleteText="Delete Inventory"
                              itemId={_.get(inventry, "Inv_Id", "")}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            
          </Table>
        ) : (
          showNoResult && (itemList == null || itemList?.length == 0) &&  (
            <div className="no-result-wrap no-result-padding">
              <h3>No results found</h3>
              <p>
                We couldn't find any listings that match your filters and search
                terms. Try a different search or reset all filters.
              </p>
              {/*<button className="btn btn-primary">Browse Ad Feed</button>*/}
            </div>
          )
        )}
      </div>
    </div>
  );
};
export default InventoryListing;
